import state from "./state"

function styleButtonOnClick(btnEl) {
    btnEl.classList.toggle("clicked")
    btnEl.setAttribute("disabled", true)
    const origContent = btnEl.textContent
    btnEl.textContent = "Copied!"

    setTimeout(() => {
        btnEl.classList.toggle("clicked")
        btnEl.removeAttribute("disabled")
        btnEl.textContent = origContent
    }, 1300)
}


export default {
    setup() {
        async function handleCopyBtnClick(event, link) {
            styleButtonOnClick(event.target)
            await navigator.clipboard.writeText(link);
        }

        return {
            links: state.value.links,
            handleCopyBtnClick,
        }
    }
}